export const appHead = {"meta":[{"charset":"utf-8"},{"http-equiv":"expires","content":"-1"},{"http-equiv":"expires","content":"Tue, 01 Jan 1980 1:00:00 GMT"},{"http-equiv":"pragma","content":"no-cache"},{"http-equiv":"cache-control","content":"no-cache"},{"http-equiv":"cache-control","content":"max-age=0"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"name":"viewport","content":"width=device-width,initial-scale=1,minimum-scale=1,viewport-fit=cover"},{"name":"description","content":"A. WebView"},{"name":"format-detection","content":"telephone=no"},{"name":"author","content":"SKTelecom"}],"link":[{"rel":"icon","type":"image/x-icon","media":"(prefers-color-scheme: light)","href":"https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/multi-llm-agent/favicon-light.ico"},{"rel":"icon","type":"image/x-icon","media":"(prefers-color-scheme: dark)","href":"https://cdn.sktapollo.com/developers/poc/app.apollo.agent/static/multi-llm-agent/favicon-dark.ico"},{"rel":"preconnect","href":"https://api.sktapollo.com"},{"rel":"preconnect","href":"https://cdn.sktapollo.com"}],"style":[],"script":[],"noscript":[],"title":"ㅤ","htmlAttrs":{"lang":"ko"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true